<div class="filter filter-city" style="padding-top: 1em">
  <h1 style="padding-bottom: 0.5em">{{ label }}</h1>
  <input id="date" type="date" (change)="setStartDate($event)" />
  <!-- <input id="date" type="date" (change)="setEndDate($event)" /> -->
</div>
